var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHeat = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 25,
  viewBox: "0 0 19 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M19 17c0 4-4.5 8-9 8-.079 0-.154-.012-.232-.014C12.702 24.846 15 22.438 15 19c0-3-5.125-4.333-4-9-3.917 0-7 4.125-7 8 0 3.266 2.158 6.234 4.563 6.87C3.649 24.067 0 19.248 0 14 0 5.875 7.625 0 14 0c-3.25 6.75 5 9.375 5 17Z"
})));
export default SvgHeat;